import React from "react";
import {
    Col,
    Drawer,
    Form, Popconfirm,
    Row, Tooltip,
    Typography,
} from "antd";
import { Button } from "src/components/actions/button";
import { CloseSvg, TrashSvg} from "src/components/Svg";

import { useAppData } from "src/store/app-data";
import styled from "styled-components";

const { Title, Text } = Typography

export function YearResultsDrawer({
                               title,
                               initialValues,
                               onClose,
                               onDelete,
                               userId
                           }) {

    const [isLoading, setIsLoading] = React.useState(false)

    const layoutConfig = useAppData((state) => state.layoutConfig);

    React.useEffect(() => {
        if (initialValues) {
        }
    }, [initialValues]);


    async function handleDelete(id) {

        /*await onDelete(id, userId);
        onClose();*/
    }

    function handleClose() {
        onClose();
    }

    const id = initialValues?.id ?? "new";

    return (
        <DrawerEdit
            width={layoutConfig.isMobile ? "90%" : "80%"}
            title={title}
            onClose={handleClose}
            open
        >
            <FlexColumns>
                {initialValues.length > 0 && initialValues.map((item, idx) => (
                    <ResultItemWrap>
                        <Text strong>{idx + 1}</Text>
                        <ResultItem>
                            <ContentItem>
                                <TextItem>
                                    <Text strong>Заголовок</Text>
                                    <Text>{item.title}</Text>
                                </TextItem>
                                <TextItem>
                                    <Text strong>Текст</Text>
                                    <Text>{item.subTitle}</Text>
                                </TextItem>
                            </ContentItem>
                        </ResultItem>
                    </ResultItemWrap>

                ))}
            </FlexColumns>
            <ButtonRow>
                <ButtonCol>
                    <Button onClick={handleClose} icon={<CloseSvg />}>
                        Закрыть
                    </Button>
                </ButtonCol>
            </ButtonRow>
        </DrawerEdit>
    );
}

const DrawerEdit = styled(Drawer)``;

const stopPropagation = (e) => {
    e?.stopPropagation()
}

const ButtonCol = styled(Col)`
  padding-bottom: 5px;
`;

const FlexColumns  = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const ResultItemWrap  = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`

const ResultItem  = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
`

const ContentItem  = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const TextItem  = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const ButtonRow = styled(Row)`
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;

  .ant-col {
    margin-left: 0.4em;
  }
`;


